module.exports = __webpack_public_path__ + "fonts/31E180_3_0.f6779f3.woff";